var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37109 7.35794C1.94949 8.39905 2.75924 10.9671 1.37109 12.9105M5.18849 5.36248C6.05609 7.0109 7.27071 11.2274 5.18849 14.906M8.5721 3.28026C9.69997 5.50708 11.279 11.3142 8.5721 16.7279M12.216 1.63184C13.662 4.26353 15.6863 11.2968 12.216 18.3763",
    stroke: "white",
    strokeWidth: 1.9087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectionIcon);
export default __webpack_public_path__ + "static/media/Conection Icon.f7fcdf1f04fe3f752f9fea9126e4fa13.svg";
export { ForwardRef as ReactComponent };